let szjzzq = [
  {
    path: '/szjzzq_home',
    name: '省中减重专区',
    component: () => import('@/pages/szjzzq/szjzzq_home')
  },
  {
    path: '/szjzzq_quiz_intro',
    name: '体质辨识',
    component: () => import('@/pages/szjzzq/szjzzq_quiz_intro')
  },
  {
    path: '/szjzzq_quiz',
    name: '体质判定中',
    component: () => import('@/pages/szjzzq/szjzzq_quiz')
  },
  {
    path: '/szjzzq_result',
    name: '体质辨识报告',
    component: () => import('@/pages/szjzzq/szjzzq_result')
  },
  {
    path: '/szjzzq_detail',
    name: '详情展示',
    component: () => import('@/pages/szjzzq/szjzzq_detail')
  }
]

export default szjzzq
